import React from 'react';
import { P as PhonePlatformContext } from './PhonePlatformContext-ee5670c1.js';

function usePhonePlatform() {
  return React.useContext(PhonePlatformContext);
}

export { usePhonePlatform as u };
